import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const OutlineIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue8de'}</MuiIcon>
        );
    })